if (!customElements.get('pt-six-photos')) {
  customElements.define('pt-six-photos', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.photos = Array.from(this.querySelectorAll('[data-photo]'));
      this.dialog = this.querySelector('dialog');
      this.image = this.dialog.querySelector('img');
      this.counter = this.dialog.querySelector('[data-counter]');
      this.addEventListener('click', (event) => {
        const photo = event.target.closest('[data-photo]');
        if (photo && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.opener = photo;
          this.show(this.photos.indexOf(photo));
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]') || event.target === this.dialog) this.dialog.close();
        if (event.target.closest('[data-prev]')) this.show(this.index - 1);
        if (event.target.closest('[data-next]')) this.show(this.index + 1);
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.dialog.addEventListener('close', () => this.opener?.focus({preventScroll: true}));
    }
    show(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      this.image.src = photo.href;
      this.image.alt = photo.querySelector('img').alt;
      this.counter.textContent = `${this.index + 1} / ${this.photos.length}`;
    }
  });
}
